import "firebase/functions";

import {
    CS_TYPES,
    getPermissionsForType
} from "./permissions";
import {
    appConfig,
    pad
} from "../../utils";
import {
    authorities,
    licences,
    ratings,
    testRatingCategories
} from "./dropdownData";

import aircraft from "../../../../resources/data/aeroplanes.json";
import aircraftCats from "../../../../resources/data/aeroplanesCats.json";
import firebase from "firebase/app";
import {
    generateDocument as generateDatabaseDocument
} from "../Database/Documents/actions.js";
import { reactive } from "vue";
import {
    revisionQuality
} from "../Database/Documents/documentUtils.js";
import roto from "../../../../resources/data/roto.json";
import rotoCats from "../../../../resources/data/rotoCats.json";

export const summaryLoadingFlags = reactive({});

export async function downloadFile({ db, rowItem, pageItem, toast }) {

    // try down load from the FlightTestCrew folder first if not found then try the CCR/CVs folder

    let url = null;
    try {
        url = await db.download(`/FlightTestCrew/${pageItem.ID}/Files/${rowItem.File}`);

    } catch (err) {
    }

    if (url === null) {
        try {

            url = await db.download(`/CCR/CVs/${pageItem.raw.OldID || pageItem.ID}/${rowItem.File}`);
        } catch (err) {
        }
    }

    if (url === null) {
        try {

            url = await db.download(`/fcaApplications/${pageItem.raw.OldID || pageItem.ID}/${rowItem.File}`);

        } catch (err) {
        }
    }



    if (url) {
        window.open(url, "__blank");
    } else {
        toast.error("File not found");
        console.error("File not found");
    }
};

export async function downloadFile2({ db, rowItem, pageItem }) {
    try {
        let url = await db.download(`/OpenForms/FlightTestCrew/${pageItem.raw.OldID || pageItem.ID}/${rowItem.File}`);
        window.open(url, "__blank");
    } catch (err) {
    }
};

function ccrFtaPreSubmitHook(pageItem) {

    let ccrFta = {};

    if (pageItem.CCR) {
        ccrFta.TEMP_CCR = pageItem.CCR;
    }

    if (pageItem.FTA) {
        ccrFta.TEMP_FTA = pageItem.FTA;
    }

    return ccrFta;
}

export const addNewApplicationUser = ({ form, toast }) => {
    form.setConfig({
        "title": "Add New Application User",
        "type": "function",
        "functionName": "provisionFlightTestCrewMember",
        "fields": [{
            "label": "First Name",
            "name": "firstName",
            "type": "text"
        }, {
            "label": "Last Name",
            "name": "lastName",
            "type": "text"
        }, {
            "label": "Email",
            "name": "email",
            "type": "text"
        }],
        preSubmitHook() {
            return { databaseURL: appConfig.firebaseConfig.databaseURL };
        },
        postSubmitHook({ functionResult }) {
            if (!functionResult?.uid) throw new Error("No user identity was returned.");
            if (functionResult.createdAuthUser && !functionResult.invitationQueued) {
                toast.warning("Flight Test Crew membership enabled, but no invitation was queued.");
            } else {
                toast.success(functionResult.invitationQueued
                    ? "Flight Test Crew membership enabled and invitation queued."
                    : "Flight Test Crew membership enabled.");
            }
        }
    });

    form.toggle();
};

export const updateApplication = ({ form, pageItem }) => {

    form.setValues({
        "User[DateOfBirth]": pageItem?.raw?.User?.DateOfBirth,
        "Credentials[Expiry]": pageItem?.raw?.Credentials?.Expiry,
        "CRM[Date]": pageItem?.raw?.CRM?.Date,
        "Role": pageItem?.raw?.Role
    });
    form.setConfig({
        "title": "Update Role",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "Role",
            "type": "dropdown",
            "name": "Role",
            "dropdownData": [{
                "label": "Pilot",
                "id": "Pilot"
            }, {
                "label": "Lead Flight Test Engineer",
                "id": "Lead Flight Test Engineer"
            }, {
                "label": "Flight Test Engineer",
                "id": "Flight Test Engineer"
            }, {
                "label": "Flight Engineer (Third crew member)",
                "id": "Flight Engineer (Third crew member)"
            }, {
                "label": "Other (Observer , Test Equipment Operator)",
                "id": "Other (Observer , Test Equipment Operator)"
            }]
        }],
        preSubmitHook() {
            return ccrFtaPreSubmitHook(pageItem);
        }
    });
    form.getDropdownData();
    form.toggle();
};

export const setLimitations = ({ form, pageItem }) => {
    form.setValues({
        "Limitations": pageItem.Limitations
    });
    form.setConfig({
        "title": "Update Application",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "Limitations",
            "type": "text",
            "name": "Limitations"
        }],
        preSubmitHook() {
            return ccrFtaPreSubmitHook(pageItem);
        }
    });
    form.toggle();
};

export const uploadFile = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Add File",
        "type": "push",
        "location": `FlightTestCrew/${pageItem.ID}/Files`,
        "fields": [{
            "label": "File",
            "name": "File",
            "type": "file",
            "accept": ".pdf,.doc,.docx,.jpg,.jpeg,.png"
        }],
        preSubmitHook() {
            return ccrFtaPreSubmitHook(pageItem);
        },
        async postSubmitHook({ db, typeRef, files }) {
            for (const file of files) {
                await db.set(`FlightTestCrew/${pageItem.ID}/Files/${typeRef.key}/File`, file[0].name);
                await db.upload(`FlightTestCrew/${pageItem.ID}/Files`, file[0]);
            }
        }
    });
    form.toggle();
};

export const uploadFile2 = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Add File",
        "type": "push",
        "location": `OpenForms/FlightTestCrew/${pageItem.ID}/Files`,
        "fields": [{
            "label": "File",
            "name": "File",
            "type": "file",
            "accept": ".pdf,.doc,.docx"
        }],
        preSubmitHook() {
            return ccrFtaPreSubmitHook(pageItem);
        },
        async postSubmitHook({ db, typeRef, files }) {
            for (const file of files) {
                await db.set(`OpenForms/FlightTestCrew/${pageItem.ID}/Files/${typeRef.key}/File`, file[0].name);
                await db.upload(`OpenForms/FlightTestCrew/${pageItem.ID}`, file[0]);
            }
        }
    });
    form.toggle();
};

export const toggleShowInMilitary = ({ form, pageItem, db }) => {
    form.setValues({
        "ShowInMilitary": pageItem.ShowInMilitary
    });
    form.setConfig({
        "title": "Toggle Show In Military",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/`,
        "fields": [{
            "label": "Show In Military",
            "name": "ShowInMilitary",
            "type": "checkbox",
            "value": pageItem.ShowInMilitary,
            "required": false
        }],
        preSubmitHook({ data }) {
            console.log(data);
            return {
                ...pageItem.raw,
                "ShowInMilitary": data?.ShowInMilitary === 'true'
            };
        }
    });
    form.toggle();
};

export const accept = ({ form, pageItem, store, db }) => {
    form.setConfig({
        "title": "Accept Application",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/`,
        "fields": [],
        preSubmitHook() {
            let ccrFta = ccrFtaPreSubmitHook(pageItem);
            return {
                ...pageItem.raw,
                ...ccrFta,
                "Accepted": true,
                "Approved": false,
                "AcceptedByID": store.getters.userID,
                "AcceptedBy": store.getters.userName,
                "Date": {
                    "Accepted": (new Date()).toISOString()
                }
            }
        },
        postSubmitHook() {
            db.update(`OpenForms/FlightTestCrew/${pageItem.ID}`, {
                "Accepted": true
            });
        }
    });
    form.toggle();
};

export const approve = ({ form, pageItem, db, store }) => {
    form.setConfig({
        "title": "Approve Application",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/`,
        "fields": [],
        async preSubmitHook() {
            const approvalDate = (new Date()).toISOString();
            let additionalData = {
                "Approved": true,
                "Date": {
                    "Approved": approvalDate
                },
                "ApprovedBy": store.getters.userName,
                "ApprovedByID": store.getters.userID
            };
            if (!pageItem.raw.FTA) {
                if (
                    pageItem.Role === "Pilot" ||
                    pageItem.Role === "Flight Engineer (Third crew member)"
                ) {
                    const fta = await createFTA(db, store);
                    additionalData.TEMP_FTA = fta.Number;
                    additionalData.FTA = fta.Number;
                    additionalData.FTAID = fta.ID;
                }
            }
            if (!pageItem.raw.CCR) {
                const ccr = await createCCR(db, store, approvalDate);
                additionalData.TEMP_CCR = ccr.Number;
                additionalData.CCR = ccr.Number;
                additionalData.CCRID = ccr.ID;
            }
            return additionalData;
        }
    });
    form.toggle();
};

export const reappove = ({ form, pageItem, db, store }) => {
    form.setConfig({
        "title": "Re-Approve Application",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/`,
        "fields": [],
        async preSubmitHook() {
            let additionalData = {
                "Approved": true,
                "Date": {
                    "Approved": (new Date()).toISOString()
                },
                "ApprovedBy": store.getters.userName,
                "ApprovedByID": store.getters.userID
            };
            return additionalData;
        }
    });
    form.toggle();
}

async function createFTA(db, store) {
    const ftaTypeLocation = "Database/DocumentTypes/-LZ_IOR6HIrxJGP2jnT5";
    let ftaType = await db.once(ftaTypeLocation);
    let baseDocumentData = getBaseDocument(store);
    let newFTA = {
        ...baseDocumentData,
        "Number": `${appConfig.docPrefix}FTA-${pad(ftaType.Count)}`,
        "Parent": `${appConfig.docPrefix}FTA-0000`,
        "ParentID": "-LZ_-c6evTCh8UQ9Y5VS",
        "ParentType": "Documents",
        "Links": {
            "-LZ_-c6evTCh8UQ9Y5VS": "---R1"
        },
        "Type": "FTA",
        "TypeID": "-LZ_IOR6HIrxJGP2jnT5"
    };
    let newDocRef = await db.push("Database/Documents", newFTA);
    let newDocData = await newDocRef.once("value");
    //update count
    await db.update(ftaTypeLocation, {
        "Count": ftaType.Count + 1
    });
    return newDocData.val();
}

async function createCCR(db, store, approvalDate) {
    let ccrType = await db.once("Database/DocumentTypes/-L_HDril6OpjoEnhaAIK");
    let baseDocumentData = getBaseDocument(store);
    baseDocumentData.Revisions[baseDocumentData.RevisionID].Quality.Approver = {
        "By": store.getters.userName,
        "Completed": true,
        "Date": approvalDate
    };
    let newCCR = {
        ...baseDocumentData,
        "Number": `${appConfig.docPrefix}CCR-${pad(ccrType.Count)}`,
        "Parent": appConfig.baseDesignChange,
        "ParentID": appConfig.baseDesignChangeID,
        "ParentType": "DesignChanges",
        "Links": {
            [appConfig.baseDesignChangeID]: "---R1"
        },
        "Type": "CCR",
        "TypeID": "-L_HDril6OpjoEnhaAIK"
    };
    let newDocRef = await db.push("Database/Documents", newCCR);
    let newDocData = await newDocRef.once("value");
    //update count
    await db.update("Database/DocumentTypes/-L_HDril6OpjoEnhaAIK", {
        "Count": ccrType.Count + 1
    });
    return newDocData.val();
}

export const generateCCR = async ({ pageItem, db, toast }) => {
    const flightTestCrew = pageItem?.raw || pageItem;
    const ccrId = flightTestCrew?.CCRID || pageItem?.CCRID;

    if (!flightTestCrew?.Approved || !ccrId) {
        toast.error("Unable to generate CCR: the application must be approved and linked to a CCR.");
        return;
    }

    try {
        const ccr = await db.once(`Database/Documents/${ccrId}`);
        if (!ccr || ccr.Type !== "CCR") {
            toast.error("Unable to generate CCR: the linked CCR document was not found.");
            return;
        }

        const revisionId = ccr.RevisionID;
        const approver = ccr.Revisions?.[revisionId]?.Quality?.Approver;
        if (!revisionId || !approver || approver.Completed !== true) {
            toast.error("Unable to generate CCR: the current CCR revision is not approved.");
            return;
        }

        if (!approver.By || approver.By === "N/A") {
            const approvedBy = flightTestCrew.ApprovedBy || pageItem?.ApprovedBy;
            const approvedDate = flightTestCrew.Date?.Approved || pageItem?.Date?.Approved;
            if (!approvedBy || !approvedDate) {
                toast.error("Unable to generate CCR: approval audit details are missing.");
                return;
            }

            const repairedApprover = {
                ...approver,
                "By": approvedBy,
                "Date": approvedDate
            };
            await db.update(
                `Database/Documents/${ccrId}/Revisions/${revisionId}/Quality/Approver`,
                repairedApprover
            );
            ccr.Revisions[revisionId].Quality.Approver = repairedApprover;
        }

        await generateDatabaseDocument({
            item: {
                ...ccr,
                "ID": ccrId
            },
            db,
            toast
        });
    } catch (error) {
        console.error("[FlightTestCrew][GenerateCCR] Failed", error);
        toast.error(error?.message || "Failed to generate CCR.");
    }
};

function getBaseDocument(store) {
    return {
        "Cancelled": false,
        "CreatedBy": store.getters.userName,
        "ExpectedTime": 1,
        "Date": {
            "Created": (new Date()).toISOString(),
            "Cancelled": "N/A",
            "Signedoff": "N/A"
        },
        "SignedOff": true,
        "Revision": "1",
        "RevisionID": "---R1",
        "Revisions": {
            "---R1": {
                "Revision": "1",
                "Reason": "Document Created",
                "ID": "---R1",
                "Date": (new Date()).toISOString(),
                "Quality": revisionQuality()
            }
        }
    };
};

export const sendApprovalEmail = ({ form }) => {
    form.setConfig({
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/`,
        "fields": [{
            "label": "Optional Message",
            "required": false,
            "name": "ApprovedMessage",
            "type": "text",
            "class": "md:col-span-3"
        }],
        preSubmitHook() {
            return {
                "SendApprovalEmail": true,
            }
        }
    });
};

export const removeApplication = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Remove Application",
        "description": "Are you sure you want to remove this application?",
        "type": "delete",
        "location": `OpenForms/FlightTestCrew/${pageItem.ID}`,
        "fields": []
    });
    form.toggle();
};

export const updateEmergencyContacts = initalLocation => ({ form, pageItem }) => {
    form.setValues({
        ...pageItem.EmergencyContact
    });
    form.setConfig({
        "title": "Update Emergency Contact",
        "type": "update",
        "location": `${initalLocation}/${pageItem.ID}/EmergencyContact`,
        "fields": [{
            "label": "First Name",
            "name": "FirstName",
            "type": "text"
        }, {
            "label": "Last Name",
            "name": "LastName",
            "type": "text"
        }, {
            "label": "Number",
            "name": "Phone",
            "type": "text"
        }, {
            "label": "Number 2",
            "name": "Phone2",
            "type": "text",
            "required": false
        }, {
            "label": "Relation",
            "name": "Relation",
            "type": "text"
        }],
        preSubmitHook() {
            return ccrFtaPreSubmitHook(pageItem);
        }
    });
    form.toggle();
};

export const override = ({ form, pageItem }) => {

    form.setValues(pageItem.raw.Override || {
        "CatOneCS23": "No Override",
        "CatOneCS23P": "No Override",
        "CatOneCS25": "No Override",
        "CatOneCS27": "No Override",
        "CatOneCS29": "No Override",
        "CatTwoCS23": "No Override",
        "CatTwoCS23P": "No Override",
        "CatTwoCS25": "No Override",
        "CatTwoCS27": "No Override",
        "CatTwoCS29": "No Override",
        "CatFourCS23": "No Override",
        "CatFourCS23P": "No Override",
        "CatFourCS25": "No Override",
        "CatFourCS27": "No Override",
        "CatFourCS29": "No Override",
        "OverrideInfo": ""
    });

    let cats = [
        "One",
        "Two",
        "Four"
    ];

    let acTypes = [
        "CS23",
        "CS23P",
        "CS25",
        "CS27",
        "CS29"
    ];

    let fields = [];

    cats.forEach((cat) => {
        acTypes.forEach(ac => {
            fields.push({
                "name": `Cat${cat}${ac}`,
                "label": `Override: Cat ${cat} ${ac}`,
                "type": "dropdown",
                "dropdownData": [{
                    "label": "No Override",
                    "id": "No Override"
                }, {
                    "label": "PiC",
                    "id": "PiC"
                }, {
                    "label": "CoP",
                    "id": "CoP"
                }, {
                    "label": "Limited to Cat 2",
                    "id": "Limited to Cat 2"
                }, {
                    "label": "Limited to Cat 4",
                    "id": "Limited to Cat 4"
                }]
            })
        });
    });

    form.setConfig({
        "title": "Select Override",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/Override`,
        "fields": [...fields, {
            "label": "Override Information",
            "name": "OverrideInfo",
            "type": "text",
            "divClass": "md:col-span-3"
        }]
    });

    form.getDropdownData();

    form.toggle();
}

export const updateLast12Months = ({ form, pageItem, rowItem }) => {
    form.setValues(rowItem);

    let index = pageItem.raw.FlightHours.Last.findIndex(i => i.Type === rowItem.Type);

    form.setConfig({
        "title": "Update Last 12 Months",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/FlightHours/Last/${index}`,
        "fields": [{
            "label": "Expiry Date",
            "name": "Expiry",
            "type": "date"
        }, {
            "name": "FlightHoursCO",
            "label": "Flight Hours CO",
            "type": "number"
        }, {
            "name": "FlightHoursCOTest",
            "label": "Flight Hours CO (Test)",
            "type": "number"
        }, {
            "name": "FlightHoursPIC",
            "label": "Flight Hours PIC",
            "type": "number"
        }, {
            "name": "FlightHoursCOTest",
            "label": "Flight Hours CO (Test)",
            "type": "number"
        }],
    });
    form.toggle();
}

export const sendBackToApplicant = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Send Back To Applicant",
        "description": "Are you sure you want to send this application back to the applicant?",
        "type": "update",
        "location": `/OpenForms/FlightTestCrew/${pageItem.ID}`,
        "fields": [],
        preSubmitHook() {
            return pageItem.raw;
        }
    });
    form.toggle();
};

export const deleteIncompleteApplication = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Delete Incomplete Application",
        "description": "Are you sure you want to delete this incomplete application?",
        "type": "delete",
        "location": `/OpenForms/FlightTestCrew/${pageItem.ID}`,
        "fields": []
    });
    form.toggle();
}

const explainer = `
<h2><strong>Competency Levels</strong></h2>
<ul>
  <li><strong>Competency Level 1</strong>: The pilot has at least 100 test flight hours, 50 total flight hours in the last period, and 20 test flight hours in the last period for the specified aircraft type.</li>
  <li><strong>Competency Level 2</strong>: The pilot has at least 50 test flight hours, 50 total flight hours in the last period, and 20 test flight hours in the last period for the specified aircraft type.</li>
  <li><strong>Competency Level 4</strong>: The pilot has at least 1000 Pilot-in-Command (PIC) flight hours and 50 total flight hours in the last period for the specified aircraft type.</li>
</ul>
`;

export const viewCatOneRequirements = ({ form }) => {
    form.setConfig({
        "title": "Requirements",
        "type": "view",
        "description": explainer,
        "fields": []
    });
    form.toggle();
}

export const editAircraftType = async ({ form, pageItem, rowItem }) => {

    form.setValues(rowItem);

    form.setConfig({
        "title": `Add Flight Hours for ${rowItem.Type}`,
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/NewFlightHours/${rowItem.ID}`,
        "fields": [{
            "label": "Total Flight Hours (All Time)",
            "info": "This is the total number of hours you have flown this aircraft type. This includes all PIC, CO, Test and Training hours.",
            "name": "Hours",
            "type": "number"
        }, {
            "label": "Test Flight Hours (All Time)",
            "info": "This is the total number of hours you have flown this aircraft type as a TEST pilot.",
            "name": "Test",
            "type": "number"
        }, {
            "type": "sectionHeader",
            "label": "Pilot in Command Hours - Last 12 Months",
            "divClass": "md:col-span-3"
        }, {
            "type": "checkbox",
            "label": "Do you have more than 1000 hours as Pilot in Command?",
            "name": "MoreThan1000PiC",
            "info": "If you have more than 1000 hours as Pilot in Command, you can skip the next section.",
            "divClass": "md:col-span-3",
            "required": false
        }, {
            "label": "Total PIC Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a pilot in command in the last 12 months as of today.",
            "name": "FlightHoursPIC",
            "type": "number"
        }, {
            "label": "Total PIC Test Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a TEST pilot in command in the last 12 months as of today.",
            "name": "FlightHoursPICTest",
            "type": "number"
        }, {
            "type": "sectionHeader",
            "label": "Co-Pilot Hours - Last 12 Months",
            "divClass": "md:col-span-3"
        }, {
            "label": "Total CO Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a co-pilot in the last 12 months as of today.",
            "name": "FlightHoursCO",
            "type": "number"
        }, {
            "label": "Total CO Test Hours (Last 12 Months)",
            "info": "This is the total number of hours you have flown this aircraft type as a TEST co-pilot in the last 12 months as of today.",
            "name": "FlightHoursCOTest",
            "type": "number"
        }],
        preSubmitHook() {
            return {
                "LastUpdated": new Date().toISOString(),
            };
        }
    });

    form.toggle();
};

export const editApplicationNotes = async ({ form, pageItem }) => {

    form.setValues({
        "Notes": pageItem.raw.Notes
    });

    form.setConfig({
        "title": "Edit Application Notes",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "Notes",
            "name": "Notes",
            "type": "richtext",
            "divClass": "md:col-span-3"
        }]
    });

    form.toggle();

};

// ============================================
// NEW ACTIONS FROM FLIGHT-TEST-CREW INTEGRATION
// ============================================

export const deleteFile = async ({ form, pageItem, rowItem, db }) => {
    form.setConfig({
        "title": "Delete File",
        "type": "delete",
        "location": `FlightTestCrew/${pageItem.ID}/Files/${rowItem.ID}`,
        "description": `Are you sure you want to delete ${rowItem.File}?`,
        "fields": [],
        async postSubmitHook() {
            await db.remove(`FlightTestCrew/${pageItem.ID}/Files/`, rowItem.File);
        }
    });

    form.toggle();
};

export const updateLicenceInformation = async ({ pageItem, form }) => {

    form.setValues({
        "Credentials[Number]": pageItem?.raw?.Credentials?.Number,
        "Authority": pageItem?.raw?.Authority,
        "Credentials[Expiry]": pageItem?.raw?.Credentials?.Expiry,
        "Credentials[Class]": pageItem?.raw?.Credentials?.Class,
        "Credentials[Medical]": pageItem?.raw?.Credentials?.Medical,
        "Licences": pageItem?.raw?.Licences ? [pageItem?.raw?.Licences].flat() : [],
        "Ratings[AeroplaneCategory]": pageItem?.raw?.Ratings?.AeroplaneCategory,
        "Ratings[HelicopterCategory]": pageItem?.raw?.Ratings?.HelicopterCategory,
        "Ratings_Others": pageItem?.raw?.Ratings?.Others ? [pageItem?.raw?.Ratings?.Others].flat() : []
    });

    form.setConfig({
        "title": "Update Licence Information",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "Licence Information",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "Licence Number",
            "name": "Credentials[Number]",
            "type": "text"
        }, {
            "label": "Licences",
            "name": "Licences",
            "type": "dropdown",
            "multiple": true,
            "dropdownData": licences,
            show() {
                return pageItem?.raw?.Role === "Pilot";
            }
        }, {
            "label": "Licence Authority",
            "name": "Authority",
            "type": "dropdown",
            "dropdownData": authorities
        }, {
            "label": "Medical Information",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "Medical Certificate Number",
            "name": "Credentials[Medical]",
            "type": "text"
        }, {
            "label": "Medical Class",
            "name": "Credentials[Class]",
            "type": "text"
        }, {
            "label": "Medical Expiry",
            "name": "Credentials[Expiry]",
            "type": "date"
        }, {
            "label": "Ratings Information",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
            show() {
                return pageItem?.raw?.Role === "Pilot";
            },
        }, {
            "label": "Flight Test Rating (Aeroplane)",
            "name": "Ratings[AeroplaneCategory]",
            "type": "dropdown",
            "dropdownData": testRatingCategories,
            show() {
                return pageItem?.raw?.Role === "Pilot";
            }
        }, {
            "label": "Flight Test Rating (Helicopter)",
            "name": "Ratings[HelicopterCategory]",
            "type": "dropdown",
            "dropdownData": testRatingCategories,
            show() {
                return pageItem?.raw?.Role === "Pilot";
            }
        }, {
            "label": "Other Ratings",
            "name": "Ratings_Others",
            "type": "dropdown",
            "multiple": true,
            "dropdownData": ratings,
            "required": false,
            show() {
                return pageItem?.raw?.Role === "Pilot";
            }
        }],
        preSubmitHook({ data }) {
            const { Ratings_Others, Ratings, ...rest } = data || {};

            if (data?.Role !== "Pilot") {
                return rest;
            }

            return {
                ...rest,
                Ratings: {
                    ...Ratings,
                    Others: Ratings_Others
                }
            };
        }
    });

    form.getDropdownData();
    form.toggle();
};

export const confirm = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Confirmation",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "type": "update",
        "submitButtonText": "Confirm",
        "submitButtonClass": "bg-green-500 hover:bg-green-700",
        "fields": [{
            "label": "Terms and Conditions",
            "type": "value",
            "grow": true,
            "divClass": "md:col-span-3",
            value() {
                return `<p>By accessing and using this system, you agree to the following terms and conditions regarding the processing of your data:</p>
                        <br/>
                        <ol>
                            <li>All data provided by the user shall be processed in accordance with applicable data protection laws and regulations.</li>
                            <li>The user consents to the collection, storage, and processing of their data for the purpose of providing the services offered by the system.</li>
                            <li>The user has the right to request access to, rectification, or erasure of their personal data held by the system.</li>
                            <li>The system will take appropriate measures to ensure the security and confidentiality of the user's data.</li>
                            <li>The user's data may be transferred to third parties only with their explicit consent or as required by law.</li>
                            <li>The user agrees to indemnify the system against any claims arising from the processing of their data.</li>
                        </ol>
                        <br/>
                    `
            }
        }],
        preSubmitHook() {
            return {
                "Completed": true,
                "Consent": true,
                "Date": {
                    "Confirmation": new Date().toISOString(),
                    "Completed": new Date().toISOString()
                }
            };
        }
    });

    form.toggle();
};

export const revokeConfirmation = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Revoke Confirmation",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "type": "update",
        "fields": [{
            "label": "Reason for Revocation",
            "key": "reason",
            "type": "textarea",
            "required": true
        }],
        preSubmitHook() {
            return {
                "Completed": false,
                "Consent": false,
                "Date": {
                    "Confirmation": "N/A",
                    "Completed": "N/A"
                }
            };
        }
    });

    form.toggle();
};

export const selectRole = async ({ form, pageItem }) => {
    form.setValues({
        "Role": pageItem?.raw?.Role,
    });

    form.setConfig({
        "title": "Select Role",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "Role",
            "name": "Role",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Pilot",
                "id": "Pilot"
            }, {
                "label": "Lead Flight Test Engineer",
                "id": "Lead Flight Test Engineer"
            }, {
                "label": "Flight Test Engineer",
                "id": "Flight Test Engineer"
            }, {
                "label": "Flight Engineer (Third crew member)",
                "id": "Flight Engineer (Third crew member)"
            }, {
                "label": "Other (Observer , Test Equipment Operator)",
                "id": "Other (Observer , Test Equipment Operator)"
            }]
        }]
    });

    form.getDropdownData();
    form.toggle();
};

export const updateContactDetails = ({ form, pageItem }) => {
    form.setValues(pageItem.raw.User || {});

    form.setConfig({
        "title": "Update Contact Details",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/User`,
        "fields": [{
            "label": "First Name",
            "name": "FirstName",
            "type": "text"
        }, {
            "label": "Last Name",
            "name": "LastName",
            "type": "text"
        }, {
            "label": "Phone Number",
            "name": "Phone",
            "type": "text"
        }, {
            "label": "Date of Birth",
            "name": "DateOfBirth",
            "type": "date"
        }]
    });

    form.toggle();
};

export const updateContactEmergencyDetails = ({ form, pageItem }) => {
    form.setValues(pageItem.EmergencyContact || {});

    form.setConfig({
        "title": "Update Emergency Contact Details",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}/EmergencyContact`,
        "fields": [{
            "label": "First Name",
            "name": "FirstName",
            "type": "text"
        }, {
            "label": "Last Name",
            "name": "LastName",
            "type": "text"
        }, {
            "label": "Contact Number",
            "name": "Phone",
            "type": "text"
        }, {
            "label": "Contact Number 2",
            "name": "Phone2",
            "type": "text"
        }, {
            "label": "Relationship",
            "name": "Relation",
            "type": "text"
        }]
    });

    form.toggle();
};

export const updateTraining = ({ form, pageItem }) => {

    form.setValues({
        "CRM[Completed]": pageItem.CRM?.Completed,
        "CRM[Date]": pageItem.CRM?.Date,
        "LFTE[Completed]": pageItem.LFTE?.Completed,
        "LFTE[Date]": pageItem.LFTE?.Date,
    });

    form.setConfig({
        "title": "Update Training Information",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "CRM Training",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "CRM Training Completed",
            "name": "CRM[Completed]",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Yes",
                "id": "true"
            }, {
                "label": "No",
                "id": "false"
            }]
        }, {
            "label": "CRM Training Completed Date",
            "name": "CRM[Date]",
            "type": "date",
            "required": false
        }, {
            "label": "LFTE Training",
            "type": "sectionHeader",
            "divClass": "md:col-span-3 border-t border-t-1",
        }, {
            "label": "LFTE Training Completed",
            "name": "LFTE[Completed]",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Yes",
                "id": "true"
            }, {
                "label": "No",
                "id": "false"
            }]
        }, {
            "label": "LFTE Training Completed Date",
            "name": "LFTE[Date]",
            "type": "date",
            "required": false
        }, {
            "label": "LFTE Training Details",
            "name": "LFTE[Details]",
            "type": "text",
            "required": false,
            "divClass": "md:col-span-3",
            "tooltip": "If you have completed LFTE training, please provide details of the training, including the date, location, provider of the training, and any other relevant information."
        }],
        preSubmitHook({ data }) {

        }
    });

    form.getDropdownData();
    form.toggle();
};

export const updateRoleExperience = ({ form, pageItem }) => {
    form.setValues({
        "RoleExperience": pageItem.RoleExperience,
    });

    form.setConfig({
        "title": "Update Other Training and Experience",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "Details of Other Training and Experience",
            "name": "OtherTraining",
            "type": "richtext",
            "divClass": "md:col-span-3 border-t border-t-1",
            "required": false
        }, {
            "label": "Role Experience",
            "name": "RoleExperience",
            "type": "richtext",
            "divClass": "md:col-span-3 border-t border-t-1",
            "required": false
        }]
    });

    form.toggle();
};

export const addAircraftType = ({ form, pageItem, attachedItems, toast }) => {

    let aeroTP = !pageItem?.AeroplaneCategory || pageItem?.AeroplaneCategory === "None";
    let rotoTP = !pageItem?.HelicopterCategory || pageItem?.HelicopterCategory === "None";

    let aircraftTypes = [
        ...(aeroTP ? aircraft : aircraftCats),
        ...(rotoTP ? roto : rotoCats)
    ].map(type => {
        return {
            "label": `${type.TCHolder} - ${type.Type}`,
            "id": `${type.TCHolder} - ${type.Type}`,
            "meta": type,
        };
    });

    form.setConfig({
        "title": "Add Aircraft Type",
        "type": "push",
        "location": `FlightTestCrew/${pageItem.ID}/NewFlightHours`,
        "fields": [{
            "label": "Aircraft Type",
            "name": "Type",
            "type": "dropdown",
            "dropdownData": aircraftTypes
        }],
        preSubmitHook({ data, dropdownData }) {
            if (attachedItems?.NewFlightHours?.items?.find(item => item?.Type === data?.Type)) {
                toast.error("You have already added this aircraft type");
                throw new Error("You have already added this aircraft type");
            }

            let selectedType = dropdownData.Type.find(t => t.id === data.Type);

            return {
                "Hours": 0,
                "Test": 0,
                "FlightHoursPIC": 0,
                "FlightHoursCO": 0,
                "FlightHoursPICTest": 0,
                "FlightHoursCOTest": 0,
                "LastUpdated": new Date().toISOString(),
                "CS": selectedType.meta.CS
            }
        }
    });

    form.getDropdownData();
    form.toggle();
};

export const updateTestFlightExperience = ({ form, pageItem }) => {
    form.setValues({
        "HasExperienceInLast90Days": pageItem.raw.HasExperienceInLast90Days,
        "Last90DaysExperienceDetails": pageItem.raw.Last90DaysExperienceDetails,
        "HasOver1000HoursTestExperience": pageItem.raw.HasOver1000HoursTestExperience,
    });

    form.setConfig({
        "title": "Update Test Flight Experience",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [{
            "label": "Have you had any test flight experience in the last 90 days?",
            "name": "HasExperienceInLast90Days",
            "type": "dropdown",
            "dropdownData": [{
                "label": "Yes",
                "id": true
            }, {
                "label": "No",
                "id": false
            }]
        }, {
            "label": "If yes, please provide details of your test flight experience in the last 90 days.",
            "name": "Last90DaysExperienceDetails",
            "type": "richtext",
            "divClass": "md:col-span-3",
            show({ liveInputData }) {
                return liveInputData.HasExperienceInLast90Days === true;
            }
        },

            // , {
            //     "label": "Do you have over 1000 hours of test flight experience?",
            //     "name": "HasOver1000HoursTestExperience",
            //     "type": "dropdown",
            //     "dropdownData": [{
            //         "label": "Yes",
            //         "id": true
            //     }, {
            //         "label": "No",
            //         "id": false
            //     }]
            // }
        ],
        preSubmitHook({ data }) {
            return {
                "Date": {
                    "FlightTestExperience": new Date().toISOString()
                }
            }
        }
    });

    form.getDropdownData();
    form.toggle();
}

export const deleteAircraftType = async ({ form, pageItem, rowItem }) => {
    form.setConfig({
        "title": "Delete Aircraft Type",
        "type": "delete",
        "location": `FlightTestCrew/${pageItem.ID}/NewFlightHours/${rowItem.ID}`,
        "description": `Are you sure you want to delete ${rowItem.Type}?`,
        "fields": []
    });

    form.toggle();
};

export const cancelApplication = ({ form, pageItem }) => {
    form.setConfig({
        "title": "Cancel / Make Inactive",
        "description": "Are you sure you want to inactivate this application?",
        "type": "update",
        "location": `FlightTestCrew/${pageItem.ID}`,
        "fields": [],
        preSubmitHook() {
            return {
                ...pageItem.raw,
                "Cancelled": true,
                "Date": {
                    ...pageItem.raw.Date,
                    "Cancelled": new Date().toISOString()
                }
            };
        }
    });

    form.toggle();
}

export const downloadFTOM = async ({ db }) => {
    const ftomLocation = appConfig.ftomLocation;

    const ftom = await db.once(ftomLocation);
    const ftomRevisionID = ftom.RevisionID;
    const file = ftom.Revisions[ftomRevisionID].File;
    const fileLocation = `${ftomLocation}/Revisions/${ftomRevisionID}/${file}`;
    const url = await db.download(fileLocation);
    window.open(url, '_blank');
};

export const summariseFlightTestCrew = async ({ pageItem, toast }) => {
    try {
        if (!pageItem?.ID) {
            toast.error("Unable to summarise flight test crew: ID is missing.");
            return;
        }

        const databaseURL = appConfig?.firebaseConfig?.databaseURL;
        if (!databaseURL) {
            toast.error("Unable to summarise flight test crew: database configuration is missing.");
            return;
        }

        const permissions = Object.fromEntries(
            CS_TYPES.map(cs => [cs, getPermissionsForType(pageItem, cs)])
        );

        summaryLoadingFlags[pageItem.ID] = true;
        toast.info("Generating flight test crew summary. This may take a moment...");
        const summarise = firebase.app().functions().httpsCallable("summariseFlightTestCrew");
        await summarise({
            id: pageItem.ID,
            databaseURL,
            raw: pageItem.raw || pageItem,
            permissions
        });
        toast.success("Flight test crew summary generated successfully.");
    } catch (error) {
        console.error("[FlightTestCrew][Summary] Callable failed", error);
        toast.error(error?.message || "Failed to generate flight test crew summary.");
    } finally {
        summaryLoadingFlags[pageItem.ID] = false;
    }
};
